var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15.926V24.074C14 27.8514 17.9071 30.2516 21.0498 28.321L27.6813 24.2471C30.7729 22.3478 30.7728 17.6522 27.6813 15.753L21.0497 11.679C17.9071 9.74835 14 12.1486 14 15.926ZM20.0029 13.3831L26.6345 17.4571C28.4552 18.5756 28.4552 21.4244 26.6344 22.5429L20.0029 26.6168C18.2333 27.704 16 26.332 16 24.074V15.926C16 13.668 18.2333 12.296 20.0029 13.3831Z",
    fill: "#2772F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayerIcon);
export default __webpack_public_path__ + "static/media/videoPlayerIcon.08b65291dd2250cda47809c93eb0c5da.svg";
export { ForwardRef as ReactComponent };